import Vue from 'vue';

import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.css';
import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';
import VueGtm from 'vue-gtm';
import VueCookies from 'vue-cookies';
import LoadScript from "vue-plugin-load-script";

import App from '@/App';
import store from '@/store';
import router from '@/router';

import Loading from '@/components/Global/Loading';

import UserPermissions from '@/plugins/UserPermissions';
import LocalStorage from '@/plugins/LocalStorage';
import GlobalMixins from '@/mixins/GlobalMixins';

import Model from '@/models/Model';
import Collection from '@/models/Collection';

import '@/util/filters';


const isDev = process.env.NODE_ENV === 'development';

window.dump = (...args) => {
	if (isDev) {
		console.log(args);
	}
};

if (true) {
	// Bugsnag for error reporting
	const bugsnagClient = bugsnag({
		apiKey: '49ea94afaaa4bbb08b73ec1a096677e1',
		releaseStage: process.env.NODE_ENV,
		// notifyReleaseStages: ['production'],
		autoDetectErrors: !isDev,
	});
	bugsnagClient.use(bugsnagVue, Vue);
	Vue.prototype.$bugsnag = bugsnagClient;
}

Vue.use(VueCookies);

if (!isDev) {
	Vue.use(VueGtm, {
		id: 'GTM-KF889NF', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
		// queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
		//   gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
		//   gtm_preview:'env-4',
		//   gtm_cookies_win:'x'
		// },
		//enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
		debug: isDev,
		//loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
		vueRouter: router, // Pass the router instance to automatically sync with router (optional)
		//ignoredViews: ['homepage'], // If router, you can exclude some routes name (case insensitive) (optional)
	});
}

Vue.use(Vuetify, {
	theme: {
		primary: '#363434',
		secondary: '#1d97c1',
		accent: '#20CAE7',
		success: '#27ae60',
		error: '#d7263d',
		info: '#2196F3',
		superUser: '#ffc0cb',
	},
});

// Attach plugins
Vue.use(UserPermissions, { store });
Vue.use(LocalStorage);
Vue.use(LoadScript);

// Attach global components
Vue.component('loading', Loading);

// Attach global mixins
Vue.mixin(GlobalMixins);

Vue.config.productionTip = false;

// Set store as static property for all models and collections
Model.prototype.$store = store;
Collection.prototype.$store = store;

const app = new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App),
});

// Attach Vue to window object for debugging
if (isDev) {
	window.vm = app;
	window.store = store;
}
